"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GlobalHamburguerMenu_component_exports = {};
__export(GlobalHamburguerMenu_component_exports, {
  GlobalHamburgerMenu: () => GlobalHamburgerMenu
});
module.exports = __toCommonJS(GlobalHamburguerMenu_component_exports);
var import_react = __toESM(require("react"));
var import_keyBy = __toESM(require("lodash/keyBy"));
var import_useOnKeydown = require("../../../utils/useOnKeydown/useOnKeydown.hook");
var import_Warning = __toESM(require("@greatmindsorg/icominds-lib/dist/IconSVG/Warning"));
var import_react_i18next = require("react-i18next");
var import_i18n = __toESM(require("../../../i18n"));
var import_GlobalHamburguerMenu = require("./GlobalHamburguerMenu.styled");
var import_roles = require("../../../utils/roles");
var import_GlobalHamburguerMenu2 = require("./GlobalHamburguerMenu.utils");
var import_GlobalHamburguerMenu3 = require("./GlobalHamburguerMenu.constants");
var _excluded = ["open", "position", "size", "backgroundColor", "topOffset", "currentRole", "closeAndEscape", "clickOutside"];
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var GlobalHamburgerMenu = /* @__PURE__ */ (0, import_react.forwardRef)(function(_ref, componentRef) {
  var _ref$open = _ref.open, open = _ref$open === void 0 ? true : _ref$open, _ref$position = _ref.position, position = _ref$position === void 0 ? "left" : _ref$position, _ref$size = _ref.size, size = _ref$size === void 0 ? "206px" : _ref$size, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? "#ffffff" : _ref$backgroundColor, _ref$topOffset = _ref.topOffset, topOffset = _ref$topOffset === void 0 ? 0 : _ref$topOffset, _ref$currentRole = _ref.currentRole, currentRole = _ref$currentRole === void 0 ? import_roles.NOT_ROLE_SELECTED : _ref$currentRole, _ref$closeAndEscape = _ref.closeAndEscape, closeAndEscape = _ref$closeAndEscape === void 0 ? true : _ref$closeAndEscape, _ref$clickOutside = _ref.clickOutside, clickOutside = _ref$clickOutside === void 0 ? true : _ref$clickOutside, props = _objectWithoutProperties(_ref, _excluded);
  var menuItemsRef = (0, import_react.useRef)(null);
  var defaultButton = (0, import_GlobalHamburguerMenu2.getMenuItemId)(props.currentApp);
  var _useState = (0, import_react.useState)(defaultButton), _useState2 = _slicedToArray(_useState, 2), activeButtonId = _useState2[0], setActiveButtonId = _useState2[1];
  var _useState3 = (0, import_react.useState)([]), _useState4 = _slicedToArray(_useState3, 2), roleLinks = _useState4[0], setRoleLinks = _useState4[1];
  var isDisabled = function isDisabled2(id) {
    return id === 1 && props.currentApp === "explore";
  };
  var handleButonClick = function handleButonClick2(itemId, itemURL) {
    return function() {
      setActiveButtonId(itemId);
      if (itemURL)
        window.location.href = itemURL;
    };
  };
  (0, import_react.useEffect)(function() {
    setRoleLinks((0, import_GlobalHamburguerMenu2.getLinkByRole)(currentRole));
  }, [currentRole]);
  var menuOptionButton = (0, import_react.useRef)(null);
  (0, import_useOnKeydown.useOnKeydown)(menuItemsRef, function(event) {
    var ArrowDown = event.ArrowDown, ArrowUp = event.ArrowUp;
    var buttons = menuItemsRef.current.querySelectorAll("button[id]");
    var buttonsId = Object.keys((0, import_keyBy.default)(buttons, "id"));
    var activeItem = document.activeElement;
    var currentPosition = buttonsId.indexOf(activeItem.id);
    var itemsSize = buttons.length;
    var fistEnabledItem = Array.from(buttons).findIndex(function(el) {
      return el.ariaDisabled === "false";
    });
    if (ArrowUp || ArrowDown) {
      var pos;
      if (ArrowUp) {
        pos = currentPosition <= 0 ? itemsSize : currentPosition - 1;
        if (currentPosition === fistEnabledItem) {
          props.onClose();
          props.focusButton();
        }
      } else {
        pos = [itemsSize, -1].includes(currentPosition) ? 0 : currentPosition + 1;
      }
      if (buttons[pos]) {
        buttons[pos].focus();
      }
    }
  });
  var _useTranslation = (0, import_react_i18next.useTranslation)(), t = _useTranslation.t;
  var errorComponent = /* @__PURE__ */ import_react.default.createElement(import_GlobalHamburguerMenu.StyledError, {
    tabIndex: -1
  }, /* @__PURE__ */ import_react.default.createElement(import_Warning.default, {
    title: "warning",
    iconSize: "l"
  }), /* @__PURE__ */ import_react.default.createElement("span", null, t("base_errorMessage_errorUnexpected")));
  var ListItems = function ListItems2(_ref2) {
    var items = _ref2.items;
    return /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, Array.isArray(items) && items.map(function(item) {
      return /* @__PURE__ */ import_react.default.createElement(import_GlobalHamburguerMenu.StyledListItem, {
        key: item.id,
        role: "presentation",
        ref: menuOptionButton
      }, currentRole === import_roles.TEACHER_ROLE && item.title === "Manage" && /* @__PURE__ */ import_react.default.createElement(import_GlobalHamburguerMenu.StyledSeparator, null), /* @__PURE__ */ import_react.default.createElement(import_GlobalHamburguerMenu.StyledButton, {
        id: "menu-item-".concat(item.id),
        isGlobalDrawer: props.isHabitatContext,
        variant: "drawerGhost",
        icon: item.icon,
        align: "left",
        iconSize: 17,
        isActive: item.id === activeButtonId,
        onClick: handleButonClick(item.id, item.url),
        disabled: isDisabled(item.id),
        "aria-current": item.id === activeButtonId ? "page" : void 0,
        role: "menuitem",
        ariaLabel: item.title,
        "data-dp-analytics-id": (0, import_GlobalHamburguerMenu3.analyticsIdGenerator)(item.id),
        tabIndex: open ? 0 : -1
      }, item.title));
    }));
  };
  return /* @__PURE__ */ import_react.default.createElement(import_react_i18next.I18nextProvider, {
    i18n: import_i18n.default
  }, /* @__PURE__ */ import_react.default.createElement(import_GlobalHamburguerMenu.StyledDrawer, {
    ref: componentRef,
    open,
    position,
    size,
    "aria-hidden": !open,
    backgroundColor,
    topOffset,
    closeAndEscape,
    clickOutside,
    handleCloseOnEscape: props.onClose,
    handleClickOutside: props.onClose,
    launchButtonRef: props.launchButtonRef,
    id: "hamburger-menu-id-controls"
  }, roleLinks === 404 ? errorComponent : /* @__PURE__ */ import_react.default.createElement(import_GlobalHamburguerMenu.StyledUnorderedList, {
    ref: menuItemsRef,
    role: "menu"
  }, /* @__PURE__ */ import_react.default.createElement(ListItems, {
    items: roleLinks
  }))));
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  GlobalHamburgerMenu
});
//# sourceMappingURL=GlobalHamburguerMenu.component.js.map